import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarButton',
  setup(__props) {

const openSidebar = function () {
    // Toggle the sidebar navigation
    document
        .getElementById("familytoday-sidebar-nav")
        .classList.toggle("active");

    // Display the navigation overlay
    document.getElementById("main-nav-overlay").style.display = "block";

    // Toggle the index page elements
    const idxEls = document.querySelectorAll("a[aria-expanded=true]");
    for (let i = 0; i < idxEls.length; i++) {
        idxEls[i].setAttribute("aria-expanded", "false");
    }

    // Toggle the secondary page elements
    const subEls = document.querySelectorAll(".collapse.in");
    for (let i = 0; i < subEls.length; i++) {
        subEls[i].classList.toggle("in");
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    id: "sidebarCollapse",
    onClick: openSidebar
  }))
}
}

})